import { Link } from 'react-router';
import { api } from '../../shared/api/client';
import type { MinistryMeetings } from '../../shared/api/types';
import { Card, ErrorState, Loading } from '../../shared/ui/components';
import { useAsync } from '../../shared/ui/useAsync';
import { MeetingsList } from './MeetingsList';

/** Reuniones del ministerio y de sus células, dentro de la ficha del ministerio. */
export function MinistryMeetingsCard({ churchId, ministryId }: { churchId: string; ministryId: string }) {
  const data = useAsync((signal) => api.get<MinistryMeetings>(`/organization/churches/${churchId}/ministries/${ministryId}/meetings`, signal), [churchId, ministryId]);
  const canCreate = data.status === 'ready' && (data.data.canCreateForMinistry || data.data.cellsICanManage.length > 0);
  return (
    <Card
      title="Reuniones"
      action={
        canCreate ? (
          <Link className="btn btn--primary" to={`/app/ministerios/${ministryId}/reuniones/nueva`}>
            Nueva reunión
          </Link>
        ) : null
      }
    >
      {data.status === 'loading' ? <Loading /> : null}
      {data.status === 'error' ? <ErrorState error={data.error} onRetry={data.reload} /> : null}
      {data.status === 'ready' ? (
        data.data.items.length === 0 ? (
          <p className="muted">No hay reuniones próximas.</p>
        ) : (
          <MeetingsList items={data.data.items} />
        )
      ) : null}
    </Card>
  );
}
